import ListProperties from "../components/properties/ListProperties";
import DefaultLayout from "../components/layout/DefaultLayout";

function BuyPropertiesPage() {
  const body = () => {
    return <ListProperties bussines="buy" />;
  };
  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default BuyPropertiesPage;
